<div class="bp-modal mod-lg">
	<bp-modal-header title="{{ 'legal_acceptence_title' | translate }}"></bp-modal-header>
	<div class="bp-modal-body">
		<div class="bp-modal-body-section">
			<div class="terms-content">
				<!-- Description-->
				<div class="bp-modal-description">{{ "you_need_to_accept_terms_and_legal" | translate }}</div>
				@if (isDynamictermAndConditionActive$ | async) {
				<!-- dynamic -->
				<terms-and-conditions-updates [bundles]="bundles" [tradable]="tradable"></terms-and-conditions-updates>
				} @else {
				<!-- Sliders -->
				<legal-settings [model]="account" [disabled]="account?.saving"></legal-settings>
				}
				<!-- Accept Button -->
				<loading-button
					[text]="'terms_accept_button'"
					[styles]="'btn-block btn-lg mt-40'"
					[tabindex]="10"
					(onClick)="onClickAccept()"
					[disabled]="isButtonDisabled">
				</loading-button>
				<!-- Decline Button -->
				<div class="flex-center-horizontal mt-20">
					<a target="_blank" (click)="onClickDecline()">{{ "terms_decline_log_out" | translate }}</a>
				</div>
			</div>
		</div>
	</div>
</div>
